(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nomz-world"] && !Shopify.designMode) return;
  try {
    
(()=>{
const controllers=new WeakMap();
function init(root){
 if(controllers.has(root))return;
 const controller=new AbortController(),signal=controller.signal;controllers.set(root,controller);
 const on=(el,event,fn)=>el?.addEventListener(event,fn,{signal});
 const reduced=()=>window.matchMedia('(prefers-reduced-motion: reduce)').matches;
 const door=root.querySelector('.nz-countdown');let doorTimer;
 const previousOverflow=document.documentElement.style.overflow;
 const stageFilm=root.querySelector('.nz-stage-film'),stageToggle=root.querySelector('[data-stage-toggle]');
 const syncStage=()=>{if(stageToggle)stageToggle.textContent=stageFilm?.paused?stageToggle.dataset.play:stageToggle.dataset.pause;};
 const startStage=()=>{if(!stageFilm||reduced())return;stageFilm.muted=true;stageFilm.play()?.catch(()=>syncStage());};
 if(stageFilm){stageToggle.hidden=false;on(stageFilm,'play',syncStage);on(stageFilm,'pause',syncStage);on(stageToggle,'click',()=>{if(stageFilm.paused){stageFilm.muted=true;stageFilm.play()?.catch(()=>syncStage());}else stageFilm.pause();});}
 const closeCountdown=()=>{clearInterval(doorTimer);if(door?.open)door.close();document.documentElement.style.overflow=previousOverflow;startStage();};
 if(door&&root.dataset.editor!=='true'&&!reduced()&&typeof door.showModal==='function'){
  try{door.showModal();document.documentElement.style.overflow='hidden';let count=3;doorTimer=setInterval(()=>{count--;if(count<=0){closeCountdown();return;}root.querySelector('[data-countdown-number]').textContent=String(count);},1000);}catch{startStage();}
  on(door,'cancel',event=>{event.preventDefault();closeCountdown();});on(root.querySelector('[data-countdown-skip]'),'click',closeCountdown);
 }else startStage();
 on(document,'visibilitychange',()=>{if(document.hidden)stageFilm?.pause();});

 root.querySelectorAll('.nz-film-card').forEach(card=>{
  const video=card.querySelector('video'),button=card.querySelector('[data-film-play]'),error=card.querySelector('.nz-film-error');
  if(!video||!button)return;button.hidden=false;
  const sync=()=>card.classList.toggle('is-playing',!video.paused&&!video.ended);
  on(video,'play',()=>{sync();if(error)error.hidden=true;});on(video,'pause',sync);on(video,'ended',sync);
  on(button,'click',()=>{if(error)error.hidden=true;const play=video.play();if(play?.catch)play.catch(()=>{if(error)error.hidden=false;});});
 });
 root.querySelectorAll('[data-scene-board]').forEach(board=>{
  const tabs=[...board.querySelectorAll('[data-scene-tab]')],panels=[...board.querySelectorAll('[data-scene-panel]')];
  const select=index=>{tabs.forEach((tab,i)=>{tab.setAttribute('aria-selected',String(i===index));tab.tabIndex=i===index?0:-1;});panels.forEach((panel,i)=>panel.hidden=i!==index);};
  tabs.forEach((tab,i)=>{on(tab,'click',()=>select(i));on(tab,'keydown',event=>{let index=i;if(event.key==='ArrowRight')index=(i+1)%tabs.length;else if(event.key==='ArrowLeft')index=(i+tabs.length-1)%tabs.length;else if(event.key==='Home')index=0;else if(event.key==='End')index=tabs.length-1;else return;event.preventDefault();select(index);tabs[index].focus();});});
 });
 root.querySelectorAll('[data-crew-quiz]').forEach(form=>{
  const questions=[...form.querySelectorAll('[data-quiz-question]')],step=form.querySelector('[data-quiz-step]'),back=form.querySelector('[data-quiz-back]'),next=form.querySelector('[data-quiz-next]'),controls=form.querySelector('[data-quiz-controls]'),results=form.querySelector('[data-quiz-results]'),message=form.querySelector('[data-quiz-message]');let index=0;
  const show=focus=>{questions.forEach((q,i)=>q.hidden=i!==index);step.textContent=String(index+1);back.hidden=index===0;message.textContent='';if(focus)questions[index].querySelector('legend').focus();};
  on(form,'submit',event=>event.preventDefault());on(back,'click',()=>{if(index>0){index--;show(true);}});
  on(next,'click',()=>{const answer=questions[index].querySelector('input:checked');if(!answer){message.textContent=form.dataset.required;questions[index].querySelector('input').focus();return;}if(index<questions.length-1){index++;show(true);return;}
   const scores={tk:0,bizzy:0,miklos:0,camo:0};questions.forEach(q=>{const value=q.querySelector('input:checked')?.value;if(value in scores)scores[value]++;});
   const highest=Math.max(...Object.values(scores));const answers=questions.map(q=>q.querySelector('input:checked')?.value);const winner=answers.find(value=>scores[value]===highest)||'tk';
   questions.forEach(q=>q.hidden=true);controls.hidden=true;form.querySelector('.nz-quiz-progress').hidden=true;message.textContent='';results.querySelectorAll('[data-quiz-outcome]').forEach(outcome=>outcome.hidden=outcome.dataset.quizOutcome!==winner);results.hidden=false;results.focus();
  });
  on(form.querySelector('[data-quiz-reset]'),'click',()=>{form.reset();index=0;results.hidden=true;controls.hidden=false;form.querySelector('.nz-quiz-progress').hidden=false;show(true);});
 });
 root.querySelectorAll('[data-newsletter-jump]').forEach(link=>on(link,'click',event=>{const input=document.querySelector('footer input[type="email"]');if(input){event.preventDefault();input.scrollIntoView({behavior:reduced()?'auto':'smooth',block:'center'});input.focus({preventScroll:true});}}));

 let returnFocus;
 root.querySelectorAll('[data-crew-quips]').forEach(box=>{const lines=box.dataset.crewQuips.split('\n').map(x=>x.trim()).filter(Boolean);let index=0;const text=box.querySelector('[data-crew-quip]');if(lines.length)text.textContent=lines[0];on(box.querySelector('[data-next-quip]'),'click',()=>{if(lines.length){index=(index+1)%lines.length;text.textContent=lines[index];}});});
 root.querySelectorAll('[data-profile]').forEach(button=>on(button,'click',()=>{
  const dialog=document.getElementById(button.dataset.profile);if(!dialog)return;
  returnFocus=button;
  root.querySelectorAll('.nz-hotspot').forEach(h=>{if(h.dataset.profile===button.dataset.profile){h.classList.remove('is-highlighted');void h.offsetWidth;h.classList.add('is-highlighted');}});
  if(!dialog.open)window.setTimeout(()=>{if(!dialog.open)dialog.showModal();},reduced()?0:260);
 }));
 root.querySelectorAll('.nz-profile-dialog').forEach(dialog=>{
  on(dialog.querySelector('[data-dialog-close]'),'click',()=>dialog.close());
  on(dialog,'close',()=>returnFocus?.focus({preventScroll:true}));
  on(dialog,'click',e=>{if(e.target===dialog){const r=dialog.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)dialog.close();}});
 });
 root.querySelectorAll('.nz-videos video').forEach(video=>on(video,'play',()=>{
  root.querySelectorAll('video,audio').forEach(other=>{if(other!==video)other.pause();});
 }));
 root.querySelectorAll('.nomz-jukebox audio').forEach(audio=>on(audio,'play',()=>root.querySelectorAll('.nz-videos video').forEach(video=>video.pause())));
 const scene=root.querySelector('[data-hollywood]');
 const updateTime=()=>{const hour=new Date().getHours();scene.dataset.time=hour>=18||hour<7?'night':'day';};
 updateTime();const timeTimer=window.setInterval(updateTime,60000);
 on(window,'focus',updateTime);
 on(window,'pageshow',updateTime);
 on(document,'visibilitychange',()=>{if(document.visibilityState==='visible')updateTime();});
 const buttons=[...scene.querySelectorAll('[data-vote]')],status=scene.querySelector('.nz-poll-status');
 const endpoint=scene.dataset.pollEndpoint;
 let clientId,hasVoted=false,busy=false,token,submitted=false,pollTimer;
 const lock=locked=>buttons.forEach(button=>button.disabled=locked);
 function paint(data){
  if(!data||!Number.isSafeInteger(data.yes)||!Number.isSafeInteger(data.no)||data.yes<0||data.no<0)throw new Error('Invalid poll response');
  if(typeof data.token!=='string'||typeof data.hasVoted!=='boolean')throw new Error('Invalid poll state');token=data.token;
  const total=data.yes+data.no;if(!Number.isSafeInteger(total))throw new Error('Invalid poll total');
  scene.querySelector('[data-poll-yes]').textContent=total?Math.round(data.yes/total*100)+' %':'—';
  scene.querySelector('[data-poll-no]').textContent=total?(100-Math.round(data.yes/total*100))+' %':'—';
  status.textContent=total?total+' '+(total===1?scene.dataset.singular:scene.dataset.totalLabel):scene.dataset.empty;
  if(data.hasVoted===true){hasVoted=true;status.textContent+=' · '+(submitted?scene.dataset.success:scene.dataset.returning);}
  lock(hasVoted||busy);
 }
 async function request(method,choice){
  const url=new URL(endpoint,location.origin);url.searchParams.set('poll',scene.dataset.pollId);
  
  const abort=new AbortController();const timeout=setTimeout(()=>abort.abort(),10000);
  signal.addEventListener('abort',()=>abort.abort(),{once:true});
  try{
   const options={method,signal:abort.signal,credentials:'omit',cache:'no-store',headers:{Accept:'application/json','X-Nomz-Voter':clientId}};
   if(method==='POST'){options.headers['Content-Type']='application/json';options.headers.Authorization='Bearer '+token;options.body=JSON.stringify({poll:scene.dataset.pollId,choice,voter:clientId});}
   const response=await fetch(url,options);if(!response.ok)throw new Error('Poll unavailable');return await response.json();
  }finally{clearTimeout(timeout);}
 }
 if(endpoint){
  try{clientId=localStorage.getItem('nomz-voter-v1');if(!clientId){clientId=crypto.randomUUID();localStorage.setItem('nomz-voter-v1',clientId);}}catch{clientId=crypto.randomUUID();}
  const refresh=()=>{if(busy||document.hidden)return;request('GET').then(paint).catch(()=>{status.textContent=scene.dataset.error;lock(true);});};refresh();pollTimer=window.setInterval(refresh,30000);on(window,'focus',refresh);
  buttons.forEach(button=>on(button,'click',async()=>{
   if(busy||hasVoted)return;busy=true;lock(true);
   try{paint(await request('GET'));if(hasVoted){busy=false;lock(true);return;}const data=await request('POST',button.dataset.vote);if(data.hasVoted!==true)throw new Error('Unconfirmed vote');hasVoted=true;submitted=true;busy=false;paint(data);}
   catch{busy=false;status.textContent=scene.dataset.error;lock(false);}
  }));
 }
 on(document,'shopify:section:unload',event=>{if(event.target.contains(root)){clearInterval(doorTimer);stageFilm?.pause();clearInterval(timeTimer);clearInterval(pollTimer);if(door?.open)door.close();document.documentElement.style.overflow='';controller.abort();controllers.delete(root);}});
}
function scan(scope){if(scope.matches?.('[data-nz-world]'))init(scope);scope.querySelectorAll?.('[data-nz-world]').forEach(init);}
scan(document);document.addEventListener('shopify:section:load',event=>scan(event.target));
})();


  } catch(e) { console.error(e); }
})();
})();
